var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.slotComponent, {
    tag: "component",
    attrs: {
      "visible-errors": _vm.visibleErrors,
      "item-class": _vm.itemClass,
      "outer-class": _vm.outerClass,
      role: _vm.role,
      "aria-live": _vm.ariaLive,
      type: _vm.type
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }